import React from "react";
import { 
  ComposedChart, Line, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, ReferenceLine, Label,
} from 'recharts';
import { useState, useEffect} from "react";
import { fetchConToken } from "helpers/fetch";
import { mapSelectedSensorsStr } from "helpers/sensors";
//import CustomizedAxisTick from './CustomizedAxisTick';
import moment from "moment";
import Swal from 'sweetalert2';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'

import "./predictionAreaChart.css"
import classes from './Prediction.module.css';


let modifiedDateData = [];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        <p className="intro">{label}</p>
        <p className="desc">Anything you want can be displayed here.</p>
      </div>
    );
  }

  return null;
};


export default function PredictionChart(props) {
  
  const { query, fillcolor, strokecolor, units, factor, selectedSensors, selectedTiempoPred, update} = props;


  let histStart ="-3d";
  let histStop ="now()";
  let predStart ="-30d";
  let predStop = "now()";
   
  
  //let predPeriods= 480; //get from state
  
  const [dataChart, setDataChart] = useState([]);
  const [presentDate, setPresentDate] = useState("");
  const [loading, setLoading] = useState(false);
  

  let mounted = true;

  const fetchData = async () => {
    
    let masterArray = [];

    try {
      
      //const respHist = await fetchConToken( `data?start=`+start+`&stop=`+stop+`&query=`+query+ `&sensors=`+sensors )  //CHANGE START to VARIABLE
      const respHist = await fetchConToken( `data?start=`+histStart+`&stop=`+histStop+`&query=`+query+ `&sensors=`+mapSelectedSensorsStr(selectedSensors) )
      const bodyHist = await respHist.json();
      
      if( bodyHist.ok ) {
        if(mounted) {
          //setData(body.data)

          masterArray = bodyHist.data.map((entry)=>{
            //console.log("Data Hist en PAC: ", "time:" + entry.time, "timeFormated:" + moment(entry.time).format('ha') );
            
            return {time: entry.time, timeFormated: ''+moment(entry.time).format('D/MM/YY(ha)'),  current: entry.value/factor, predict: null ,  range: null}
          })
          console.log("modified Date Hist Array 1 PC: ", masterArray);
          
          //setData3(modifiedDate);

        }
      }else{
        Swal.fire('Error colectando historicos para predicciones 0xPD0PC4', "Error Interno", 'error');
      }


      
      const resp = await fetchConToken( `predictions?start=`+predStart+`&stop=`+predStop+`&periods=`+selectedTiempoPred+ `&query=`+query+ `&sensors=`+mapSelectedSensorsStr(selectedSensors) )
      //const resp = "none";
      const body = await resp.json();
      
      console.log("sensors in effect in predChart PC :" + mapSelectedSensorsStr(selectedSensors));
      
      modifiedDateData = [];


      if( body.ok ) {
          if(mounted) {
              //setData(body.data)
              let parsedJson = JSON.parse(body.data);
         
            modifiedDateData = parsedJson.map((entry)=>{
              let arrayRange = [];
              arrayRange.push(entry.range[0]/factor);
              arrayRange.push(entry.range[1]/factor);
              
              let isoTime = new Date(entry.time).toISOString();
              return {time: isoTime,  timeFormated: ''+moment(isoTime).format('D/MM/YY(ha)'), current: null, predict: entry.value/factor,  range: arrayRange }
              //return {time: ''+moment.unix((entry.time + '000000000')).format('D/MM/YY(ha)'),  value: entry.value/factor,  range: arrayRange }
            
            })
            
            modifiedDateData[0].current = masterArray[masterArray.length-1].current; //fill gap for recharts - repeat last entry
            masterArray.push.apply(masterArray, modifiedDateData);   //merge arrays not making new one

            console.log("first line pred in PC: ", modifiedDateData[0] );
            setDataChart(masterArray); 
            setPresentDate(modifiedDateData[0].time);

            setLoading(false);
            

          }
      }else{
        Swal.fire('Error colectando predicciones 0xP0PC6', "Error de respuesta", 'error');
      }
    } catch (error) {
      Swal.fire('Error colectando predicciones 0xP0PC5', "No existen predicciones", 'error');
    }
  }



  useEffect(() => {
    
    
      setLoading(true);
      fetchData();
      
      //console.log("average Display in PC: ", average);   
    
    return () => mounted = false;
  }, [update])
  
  function formatXAxis(tickItem) {
    // If using moment.js
    return moment(tickItem).format('D/MM/YY(ha)')
  }


  return (
    
      <div style={{ width: '100%', height: '100%' }}>
        
        {(loading) ? (
          <div className={classes.loading} style={{display: "flex", justifyContent: 'center', alignItems: 'flex-start'}}>
                <LoadingSpinner />
          </div>
        ):(
           <>
            

            
            <ResponsiveContainer key={`rcs_1`} width="100%" height={200}>
                    <ComposedChart
                      data={dataChart}
                      margin={{
                        top: 10,
                        right: 10,
                        left: -20,
                        bottom: 0,
                      }}
                      key={`rcs_2`}
                    >
                      
                      <CartesianGrid strokeDasharray="3 3" />
                    <XAxis  dataKey="time"  allowDuplicatedCategory={false} tickFormatter={formatXAxis} interval="preserveEnd" minTickGap={50}  />
                    {/* <XAxis  dataKey="time"  allowDuplicatedCategory={false} interval="preserveEnd" minTickGap={50}  /> */}
                    
                      <YAxis type="number" domain={['auto', 'auto']}/>
                      <Tooltip 
                        wrapperStyle={{ backgroundColor: "beige" }}
                        labelStyle={{ color: "darkblue" }}
                        itemStyle={{ color: "ButtonText" }}
                        formatter={function(value) {
                          //console.log("tooltip", value);
                          if (Array.isArray(value)){
                            return (`${(value[0]).toFixed(2)} - ${(value[1]).toFixed(2)} ` + units );
                          }
                          return (`${Number(value).toFixed(2)} ` + units );
                        }}
                        labelFormatter={function(value) {
                          return (moment(value).format('D/MM/YY(ha)'));
                        }}
                      
                      />

                      <ReferenceLine x={presentDate} stroke="green" label={{value:"Present", position:"insideTop"}} /> 
                      
                      <Line type="monotone" dataKey="current" strokeWidth={1} stroke={strokecolor} dot={false}  />
                      
                      <Line type="monotone" dataKey="predict" strokeWidth={1} stroke="red" dot={false}  />
                      <Area type="monotone" dataKey="range"  stroke="#8884d8" strokeWidth={0}  fill="#8884d8" />
                      
                      
      
                     
      
      
                    </ComposedChart>
                  </ResponsiveContainer>



          </>
          
        )
        }

      </div>
    
  );

};






